import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { ResenjeZaPlacenoOdsustvo } from './resenje-za-placeno-odsustvo';

@Component({
  selector: 'yt-resenje-za-placeno-odsustvo-modal-update',
  templateUrl: './resenje-za-placeno-odsustvo-modal-update.component.html'
})
export class ResenjeZaPlacenoOdsustvoModalUpdateComponent
extends BaseModalUpdateComponent<ResenjeZaPlacenoOdsustvo>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<ResenjeZaPlacenoOdsustvo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
  

  ngOnInit() {
    
    }

}
